import pongEventHadler from './pong'
import routeToAgentEventHadler from './route-to-agent'

export default {
  pongEventHadler,
  routeToAgentEventHadler,
}
